export default "__VITE_ASSET__DjysZZbe__"